export default {
  MEALS: (state) => state.meals,
  MEALS_AUTOCOMPLETE: (state) =>
    state.meals.data.map((meal) => ({ label: meal.title, value: meal.id })),
};
